import * as React from 'react';

const Filter = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={18} height={18} {...props}>
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M7.483 8.847v7.15a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-7.15a7.5 7.5 0 0 0 5.984-6.814.5.5 0 0 0-.499-.533H2a.5.5 0 0 0-.499.533 7.5 7.5 0 0 0 5.982 6.814"
        />
    </svg>
);
export default Filter;
